// Explicit synthetic preview data. Never used as component defaults.

export const FIXTURE_APPROVALS = [
  { id: 'leo-walk-biscuit', actor: 'Leo', title: 'Walk Biscuit', amount: 1.0, when: 'just now' },
  { id: 'maya-dishwasher', actor: 'Maya', title: 'Unload dishwasher', amount: 0.75, when: '6:12 PM' },
  { id: 'finn-bed', actor: 'Finn', title: 'Make your bed', amount: 0.5, when: '4:12 PM' },
];

export const FIXTURE_PAYDAY = {
  week: 12,
  settleLabel: 'Settles Friday 6:00 PM',
  kids: [
    { id: 'maya', name: 'Maya', questsDone: 7, questsTotal: 8, earned: 7.25 },
    { id: 'leo', name: 'Leo', questsDone: 9, questsTotal: 10, earned: 9.5 },
    { id: 'finn', name: 'Finn', questsDone: 3, questsTotal: 6, earned: 4.5 },
  ],
  total: 21.25,
  splits: [
    { id: 'maya', name: 'Maya', save: 50, share: 10, spend: 40 },
    { id: 'leo', name: 'Leo', save: 60, share: 10, spend: 30 },
    { id: 'finn', name: 'Finn', save: 25, share: 25, spend: 50 },
  ],
  hold: { name: 'Finn', questsDone: 3, questsTotal: 6, earned: 4.5, possible: 8.0 },
};

export const approvalsFixture = {
  approvals: FIXTURE_APPROVALS,
  payday: FIXTURE_PAYDAY,
  parentName: 'Sara',
  notifications: 3,
};
